'use client'
import { useRef, useState } from 'react'
import { useFastCasualContext } from '../context/FastCasualContext'
import EmailVerificationDialog from './EmailVerificationDialog'

interface EmailVerificationCompProps {
  buttonLabel: string
  successLabel: string
  position?: 'left' | 'center'
}

const EmailVerificationComp = (props: EmailVerificationCompProps) => {
  const { buttonLabel, successLabel, position } = props
  const [open, setOpen] = useState(false)
  const { verified } = useFastCasualContext()
  const btnEle = useRef<HTMLButtonElement>(null)

  return (
    <>
      <EmailVerificationDialog
        component="popover"
        anchorEle={btnEle.current!}
        anchorOrigin={
          position
            ? {
                vertical: 'center',
                horizontal: 'center'
              }
            : undefined
        }
        transformOrigin={
          position
            ? {
                vertical: 'center',
                horizontal: position
              }
            : undefined
        }
        open={open}
        handleClose={() => setOpen(false)}
      />

      {!verified && (
        <button
          ref={btnEle}
          className="w-60 px-4 py-3 rounded text-sm font-normal"
          style={{ background: '#282824', color: '#FFFFFF' }}
          onClick={(e) => {
            setOpen(true)
            e.stopPropagation()
          }}>
          {buttonLabel}
        </button>
      )}
      {/* {verified && (
        <button
          ref={btnEle}
          className="w-60 px-4 py-3 rounded text-sm font-normal cursor-default"
          style={{ background: '#4BB543', color: '#FFFFFF' }}>
          {successLabel}
        </button>
      )} */}
    </>
  )
}

export default EmailVerificationComp
